import { IScene, SceneType } from '@/interface';

import { templateEndGroupNode, templateGroupNode, templateOptionGroupNode } from '../nodes/templateNode';

/**
 * 根据场景类型获取模板组
 * AI幕，互动选项幕，结局幕，三种模版
 * AI幕转为结局幕，模版不变
 * 互动选项幕转为互动选项幕，模版需要变
 */
export const getTemplateGroup = (scene: IScene) => {
  const { sceneType, isFinal } = scene || {};
  switch (sceneType) {
    case SceneType.SCENE_TYPE_FINAL:
      return templateEndGroupNode;
    case SceneType.SCENE_TYPE_OPTION:
      if (isFinal) {
        return templateEndGroupNode;
      }
      return templateOptionGroupNode;
    default:
      return templateGroupNode;
  }
};
